// 导入组件，组件必须声明 name
import AcePermissionSelector from "./src/main";
// 为组件添加 install 方法，用于按需引入
AcePermissionSelector.install = function (Vue) {
  Vue.component(AcePermissionSelector.name, AcePermissionSelector);
};
export default AcePermissionSelector;
